import PageHeader from 'components/general/pageHeader';
import React from 'react';

export const MyTeam = () => {
    return (
        <div>
            <PageHeader title="My Team" />
            <section className="content mtm10" data-testid="teams-content">
                <div>My Team Page Coming Soon</div>
            </section>
        </div>
    );
};

export default MyTeam;
